<template>
    <div class="agreement-page">
        <div class="main-section">
            <p>导言</p>
            <p>欢迎使用卓师兄恢复大师！</p>
            <p>卓师兄恢复大师在此特别提醒您在安装卓师兄恢复大师APP或使用卓师兄恢复大师服务之前，请认真阅读本</p>
            <p>《用户协议》（以下简称“协议”），确保您充分理解本协议中各条款。请您审慎阅读并选择接受或不接受
                本协议。除非您接受本协议所有条款，否则您无权使用本协议所涉服务。您的检测、咨询、使用、提交订
                单等行为将视为对本协议的接受，并同意接受本协议各项条款的约束。如果您未满18周岁，请在法定监
                护人的陪同下阅读本协议。</p>
            <h1 style="margin: 0">一、协议范围</h1>
            <p>1.1&nbsp;&nbsp;本协议是您与卓师兄恢复大师之间的协议。“卓师兄恢复大师”是指卓师兄恢复大师APP
                及其相关服务可能存在的运营关联单位。“用户”是指使用卓师兄恢复大师相关服务的使用人，在本协议中
                更多地称为“您”。</p>
            

            <p>1.2&nbsp;&nbsp;本协议项下的许可内容是指卓师兄恢复大师向用户提供的包括但不限于iOS移动设备的
                数据检测与咨询（以下简称“服务”）。</p>

            <p>1.3&nbsp;&nbsp;本协议可由卓师兄恢复大师随时更新，更新后的协议条款一旦公布即代替原来的协议条
                款，恕不再另行通知，您可在本网站查阅最新版协议条款。在卓师兄恢复大师修改协议条款后，如果您不
                接受请立即停止使用服务，继续使用，则被视为接受修改后的协议。</p>

            <h1>二、个人隐私信息保护</h1>

            <p>2.1&nbsp;&nbsp;您在使用本服务的过程中，需要填写或提交一些必要的信息，如法律法规、规章规范性
                文件（以下称“法律法规”）规定的需要填写的身份及注册信息、为更好的使用本服务而提交的设备及操作
                信息。如您提交的信息不完整或不符合法律法规的规定，则您可能无法使用本服务或在使用本服务的过程
                中受到限制。</p>

            <p>2.2&nbsp;&nbsp;第三方平台记录信息。使用腾讯微信、腾讯QQ、新浪微博等第三方平台账号注册、登录
                、使用卓师兄恢复大师服务的，将被视为您完全理解、同意并接受卓师兄恢复大师包括但不限于收集、统
                计、分析等方式使用其在第三方平台填写的全部信息。用户一旦使用第三方平台账号注册、登录、使用
                卓师兄恢复大师服务的，卓师兄恢复大师对该第三方平台记录信息的任何使用，均被视为已经获得了用户本人的
                完全同意并接受。</p>

            <p>2.3&nbsp;&nbsp;对于您在卓师兄恢复大师提交的所涉及包括个人真实姓名、电话、电子邮件、通信地址
                等在内的用户个人信息、第三方平台账号信息等个人隐私信息卓师兄恢复大师承诺均予以严格保密。</p>

            <p>2.4&nbsp;&nbsp;卓师兄恢复大师将采取技术措施和其他必要措施，确保用户个人隐私信息安全，防止在
                本服务中收集的用户个人隐私信息泄露、毁损或丢失。在发生前述情形或者卓师兄恢复大师发现存在发生
                前述情形的可能时，将及时采取补救措施。</p>

            <p>2.5&nbsp;&nbsp;卓师兄恢复大师未经您同意不向任何第三方公开、透露用户个人隐私信息。但以下特定
                情形除外：
                （1）卓师兄恢复大师根据司法机关或行政机关基于法定程序要求提供的；
                （2）由于用户将其个人隐私信息告知他人或与他人共享个人隐私信息，由此导致的任何个人信息的泄漏，或其他非因卓师兄恢复大师原因导致的个人隐私信息的泄露；
                （3）您自行向第三方公开其个人隐私信息；
                （4）任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露。</p>

            <p>2.6&nbsp;&nbsp;用户同意卓师兄恢复大师可在以下事项中使用用户的个人隐私信息：
            （1）卓师兄恢复大师向用户及时发送重要通知，如个人服务信息、本协议条款的变更；
            （2）卓师兄恢复大师内部进行审计、数据分析和研究等，以改进卓师兄恢复大师的产品、服务和与用户之间的沟通；
            （3）在卓师兄恢复大师运营商——昆山春苗网络技术有限公司旗下软件内部共享，以向您提供昆山春苗网络技术有限公司旗下软件的优惠服务；
            （4）依本协议约定，卓师兄恢复大师管理、审查用户信息及进行处理措施；
            （5）适用法律法规规定的其他事项。</p>

            <h1>三、服务条款</h1>

            <p>3.1&nbsp;&nbsp;卓师兄恢复大师在线提供网络服务时，会对部分服务收取一定费用，卓师兄恢复大师会
                对各项服务的收费标准予以明确指示，如您拒绝支付此类费用，卓师兄恢复大师有权不提供相关服务。</p>

            <p>3.2&nbsp;&nbsp;卓师兄恢复大师提交订单获得预约工程师的各类服务指的是针对提交订单的本人提供服
                务，工程师会依据用户提交订单时提供的联系方式，与用户取得联系并提供相关收费服务。</p>

            <p>3.3&nbsp;&nbsp;您需要确保工程师在给您提供服务时，您提供的待操作的设备和数据确实为您本人所有。</p>

            <p>3.4&nbsp;&nbsp;恢复数据属于非实物服务，不具有可逆性，数据恢复完成一经确认，即代表收费服务全
                部进行完毕，代表您满意了本次服务结果，未来再发生一些其他意外或者您不满意恢复服务的结果，不支
                持申请退款。</p>

            <p>3.5&nbsp;&nbsp;卓师兄恢复大师应用内会提供多种套餐，建议您在支付前充分的了解各自的区别，在了
                解后再进行付款以获得相应的服务，各类服务费不支持退款，数据恢复功能服务费是根据您的数据恢复情
                况进行收取，在工程师告知您的数据可以恢复，需要支付功能服务费，在您支付成功后，工程师会根据您
                的付款确认结果，帮您最终恢复数据。</p>

            <p>3.6&nbsp;&nbsp;在您选择相应服务并支付成功后，无论哪一种类型的套餐，工程师会尽可能的在承诺的
                服务时间范围内与您取得联系，如果工程师多次联系您都无法与你取得联系时，您的订单服务时间将会顺
                延，可以依据工程师跟您的进一步沟通结果再次确认服务时间，如果一直未能联系到您，且您也没有主动
                联系卓师兄恢复大师工程师，您的订单会一直顺延直到您来联系为止，卓师兄恢复大师不承担因您个人原
                因导致数据无法恢复或服务无法进行的结果或任何责任。</p>

            <p>3.7&nbsp;&nbsp;数据恢复功能服务费和人工检测费的价格可能会因为人力成本提高或降低，以及数据恢
                复的难度变化做相应调整，价格的调整不需要逐一通知新老用户。</p>
            

            <h1>四、服务的中断和终止</h1>

            <p>4.1&nbsp;&nbsp;因发生昆山春苗和卓师兄恢复大师不可抗拒的事由，如政府行为、不可抗力，导致
                卓师兄恢复大师服务无法继续，昆山春苗会以最快的速度通知卓师兄恢复大师用户，但不承担由此对
                卓师兄恢复大师用户造成的任何损失并不退还预约人工检测费。</p>
            <p>4.2&nbsp;&nbsp;如卓师兄恢复大师用户违反或被视为违反本服务条款中的内容，昆山春苗有权在不通知
                卓师兄恢复大师用户的情况下立即终止您已购买的所有服务。</p>
            <p>4.3&nbsp;&nbsp;昆山春苗未行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一
                或部分行使其在本协议项下的任何权利并不排斥其任何其它权利的行使。昆山春苗随时有权要求您继续履
                行义务并承担相应的违约责任。</p>

            <h1>五、法律的适用和管辖</h1>

            <p>5.1&nbsp;&nbsp;本服务条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本服务条款
                因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。</p>

            <p>5.2&nbsp;&nbsp;如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，则争议各
                方一致同意将发生的争议提交协商不成时，任何一方均可向卓师兄恢复大师经营者所在地人民法院提起诉
                讼。</p>

            <p style="text-align: right">昆山春苗网络技术有限公司</p>

            <p style="text-align: right">法务部</p>

        </div>
    </div>
</template>

<script>

import axios from 'axios'

export default {
    metaInfo: {
        title: '卓师兄恢复大师', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '卓师兄恢复大师'
        },{                 // set meta
          name: 'description',
          content: '卓师兄恢复大师'
        }]
    },
    data(){
        return{
            
        }
    },
    mounted(){

    },
    created(){
        
    },
    methods:{
        
    },
    components:{
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/css/base.scss';
.agreement-page {
    padding-bottom: 10px;
    .main-section{
        padding:20px 20px 0;
    }
    .main-section > h1 {
        color: #262626;
        font-size: 16px;
        font-weight: bold;
        margin-top: 20px;
    }
    .main-section > p {
        font-size: 14px;
        color: #262626;
        line-height: 21px;
        margin-top: 16px;
    }
    
}
</style>



// WEBPACK FOOTER //
// src/static/majia01/Agreement.vue